import { postJson, getJson, postObject } from '../ChoiceApi';
import { IReportRequest, IReportResponse } from '../Models/Reports/BillerProductivityReportModel';
import * as FinancialReportModel  from '../Models/Reports/FinancialReportModel';

export const billerProductivity = {
    async runBillerProductivityReport(payload: IReportRequest): Promise<IReportResponse[]> {
        return (await postJson("api/Reports/ProductivityReport/BillerProductivityReport", payload)) as IReportResponse[];  
    },

}

export const dailyFinancials = {
    async getDailyFinancialReportData(payload: FinancialReportModel.IFinancialReportInputs): Promise<FinancialReportModel.IFinancialReportData | undefined> {
        return await postObject("api/FinancialReport/DailyFinancialReport", payload);  
    },

}

export const monthlyFinancials = {
    async getMonthlyFinancialReportData(payload: FinancialReportModel.IFinancialReportInputsMonthly): Promise<FinancialReportModel.IFinancialReportDataMonthly | undefined> {
        return await postObject("api/FinancialReport/MonthlyFinancialReport", payload);  
    },

    async getMonthlyFinancialReportDrillDownData(payload: FinancialReportModel.IMonthlyDrillDownInputParameters): Promise<FinancialReportModel.IFinancialReportResults[] | undefined> {
        return await postObject("api/FinancialReport/MonthlyFinancialDrillDownReport", payload);  
    },
}

export const reportsLanding = {
    async getReportsLandingReportList(): Promise<FinancialReportModel.IReportsLandingMultiData> {
        return await getJson("api/FinancialReport/ReportsLandingReportList") as FinancialReportModel.IReportsLandingMultiData;  
    },

}
